import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import easesCustom from '../fx/CustomEases';

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.staggers = this.DOM.view.querySelectorAll('.fxStagger');
    this.DOM.separator = this.DOM.view.querySelectorAll('.fxSeparator');

    //? Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    let setDelay = this.DOM.view.getAttribute('data-delay') * 1
    if(Env.mobileCSS) {
      setDelay = 0
    }
    const offsetStart = (Env.mobileCSS)?'top 80%':'top 50%';
    this.tl = gsap.timeline({
      delay:setDelay,
      scrollTrigger: {
        trigger:this.DOM.view,
        start:offsetStart
      }
    })

    this.tl.add([
      gsap.fromTo(
        this.DOM.view,
        {
          autoAlpha:0,
        },
        {
          autoAlpha:1,
          duration:.5,
          ease:'quint.out',

        }
      )
    ]).add([
      gsap.fromTo(
        this.DOM.staggers,
        {
          autoAlpha:0,
          y:30
        },
        {
          y:0,
          autoAlpha:1,
          duration:1,
          ease:'power3.out',
          stagger:.2

        }
      ),
      gsap.fromTo(
        this.DOM.separator,
        {
          scaleX:0,
          transformOrigin:'left top'
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.7
        }
      )
    ],'-=.4')

  }
}
